import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpringPage } from '@shared/page';
import { Lang } from '@shared/utils/lang';
import { Observable } from 'rxjs';
import { OgoResponse } from './ogo-response';
import { MFA } from '@shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminUserService {
  constructor(private readonly http: HttpClient) {}

  loadUsersPaginated(searchTerm, index, size) {
    return this.http.get<SpringPage<User>>(`admin/users?page=${index}&size=${size}&filter=${searchTerm}`, {});
  }

  updateUser(userId: number, data: EditableUser): Observable<User> {
    return this.http.put<User>('admin/users/' + userId, data);
  }

  resendRegistrationMail(email: string): Observable<OgoResponse> {
    return this.http.post<OgoResponse>('utilisateur/generateToken/registration', { data: { email } });
  }

  getUser(userId: number): Observable<User> {
    return this.http.get<User>('admin/users/' + userId);
  }
}

export const ROLES = ['VIEWER', 'SITE_ADMIN', 'CLUSTER_ADMIN', 'ORGANIZATION_ADMIN', 'OWNER'] as const;

export type UserRole = (typeof ROLES)[number];

export const ROLES_MAP: { [key in UserRole]: string } = {
  VIEWER: 'Viewer',
  SITE_ADMIN: 'SiteAdmin',
  CLUSTER_ADMIN: 'ClusterAdmin',
  ORGANIZATION_ADMIN: 'AccountAdmin',
  OWNER: 'Owner',
} as const;

export type EditableUser = {
  email: string;
  firstName?: string;
  lastName?: string;
  profile: string;
  lang: Lang;
  active: boolean;
  apiKey?: string;
};

export type User = EditableUser & {
  id: number;
  hasApiKey: boolean;
  lastLoginDate: number | string;
  mfa: MFA;
  organizations: {
    role: string;
    organization: {
      id: number;
      code: string;
      name: string;
    };
  }[];
  createdAt: number | string;
  createdBy: {
    firstName: string;
    lastName: string;
  };
};
